import React, { useState, useRef, useEffect } from 'react';

// Lazy load the YouTube player
const VedioPlayer = ({ url }) => {
    const [isLoading, setIsLoading] = useState(true);
    const iframeRef = useRef(null);

    const loaderStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #3498db',
        borderRadius: '50%',
        width: '70px',
        height: '70px',
        animation: 'spin 2s linear infinite',
    };

    const iframeStyles = {
        width: '1000px',
        height: '800px',
        border: 'none',
    };

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    const styles = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe) {
            iframe.addEventListener('load', handleIframeLoad);
            return () => {
                iframe.removeEventListener('load', handleIframeLoad);
            };
        }
    }, []);

    return (
        <>
            <style>{styles}</style>
            {isLoading && <div style={loaderStyle}></div>}
            <iframe
                ref={iframeRef}
                src={url}
                width="1000"
                height="800"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
            ></iframe>
        </>
    );
};

export default VedioPlayer;
